import { PropsWithChildren, createContext, useState } from 'react'
import { ListProductsResponse, MemberAv } from '../../models/query-member';

interface QueryMemberContextModel {
    showOtpModal: boolean;
    products: ListProductsResponse | null;
    member: MemberAv | null;
    arrangeShowOtpModal: (x: boolean) => void;
    fillProducts: (x: ListProductsResponse | null) => void;
    fillMember: (x: MemberAv | null) => void;
}

const initialMemberAv: MemberAv = { 
    avNo: '',
    goldenCode: '',
    name: '',
    surname: '',
    memberTypeId: 0,
    memberTypeCode: '',
    memberTypeDescription: '',
    birthDate: '',
    companyId: 0,
    companyName: '',
    hasSiblingRelationPerm: false,
    siblingsNames: []
}

const defaultModel: QueryMemberContextModel = {
    showOtpModal: false,
    products: null,
    member: initialMemberAv,
    arrangeShowOtpModal: (x: boolean) => { },
    fillProducts: (x: ListProductsResponse | null) => { },
    fillMember: (x: MemberAv | null) => { }
}

export const QueryMemberContext = createContext<QueryMemberContextModel>(defaultModel);

const QueryMemberContextProvider = (props: PropsWithChildren) => {
    const [showOtpModal, setShowOtpModal] = useState<boolean>(defaultModel.showOtpModal);
    const [products, setProducts] = useState<ListProductsResponse | null>(defaultModel.products);
    const [member, setMember] = useState<MemberAv | null>(defaultModel.member);

    const arrangeShowOtpModal = (show: boolean) => {
        setShowOtpModal(show);
    }

    const fillProducts = (data: ListProductsResponse | null) => {
        setProducts(data);
    }

    const fillMember = (data: MemberAv | null) => {
        setMember(data ?? initialMemberAv);
    }

    return (
        <QueryMemberContext.Provider value={{
            showOtpModal, products, member,
            arrangeShowOtpModal, fillProducts, fillMember
        }}>
            {props.children}
        </QueryMemberContext.Provider>
    );
}

export default QueryMemberContextProvider;